var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyBlockIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6926 10.69L25.9793 5.97667C25.3543 5.35167 24.5059 5 23.6226 5H11.6693C9.8276 5 8.33594 6.49167 8.33594 8.33333V31.6667C8.33594 33.5083 9.8276 35 11.6693 35H28.3359C30.1776 35 31.6693 33.5083 31.6693 31.6667V13.0467C31.6693 12.1633 31.3176 11.315 30.6926 10.69V10.69Z",
    stroke: "#393939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6693 13.3333H25.0026C24.0826 13.3333 23.3359 12.5867 23.3359 11.6667V5",
    stroke: "#393939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 18.5335H18.75",
    stroke: "#393939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 23.3333H18.75",
    stroke: "#393939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 28.1331H18.75",
    stroke: "#393939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5443 18.3335C13.4293 18.3335 13.3359 18.4268 13.3359 18.5418C13.3359 18.6568 13.4293 18.7502 13.5443 18.7502C13.6593 18.7502 13.7526 18.6568 13.7526 18.5418C13.7526 18.4268 13.6593 18.3335 13.5443 18.3335",
    stroke: "#393939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5443 23.125C13.4293 23.125 13.3359 23.2183 13.3359 23.3333C13.3359 23.4483 13.4293 23.5417 13.5443 23.5417C13.6593 23.5417 13.7526 23.4483 13.7526 23.3333C13.7526 23.2183 13.6593 23.125 13.5443 23.125",
    stroke: "#393939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5443 27.9165C13.4293 27.9165 13.3359 28.0098 13.3359 28.1248C13.3359 28.2398 13.4293 28.3332 13.5443 28.3332C13.6593 28.3332 13.7526 28.2398 13.7526 28.1248C13.7526 28.0098 13.6593 27.9165 13.5443 27.9165",
    stroke: "#393939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBlockIcon);
export default __webpack_public_path__ + "static/media/empty-block-icon.baed3e0ba87cd2d2b6ab355617bc31ac.svg";
export { ForwardRef as ReactComponent };